export default __webpack_public_path__ + "static/media/jp.8928b83d.svg";